document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-buy-now]');
  if (!button || button.disabled) return;

  const form = button.closest('form');
  const idInput = form && form.querySelector('[name="id"]');
  if (!idInput || !idInput.value) return;

  button.disabled = true;
  button.classList.add('loading');
  const spinner = button.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  fetch(button.dataset.cartAddUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: idInput.value, quantity: 1 }),
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((err) => {
          throw new Error((err.errors && err.errors.quantity && err.errors.quantity[0]) || err.description || 'Unable to add to cart');
        });
      }
      return response.json();
    })
    .then(() => {
      let rootUrl = button.dataset.rootUrl || '/';
      if (!rootUrl.endsWith('/')) rootUrl += '/';
      window.location.href = rootUrl + 'checkout';
    })
    .catch((error) => {
      button.disabled = false;
      button.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      window.alert(error.message);
    });
});
